export const JOBS = [
  {
    id: 'manager-human-resources',
    title: 'Manager Human Resources',
    location: 'Islamabad',
    department: 'Human Resources',
    type: 'Full-Time',
    overview:
      'Capital Care International Hospital & Capital Diagnostic Centre are seeking a dynamic and people-oriented Manager Human Resources to lead and strengthen HR operations across our healthcare facilities in Islamabad. This role requires a structured HR professional with strong knowledge of compliance, workforce management, and employee engagement within a regulated healthcare environment. The Manager HR will be responsible for overseeing end-to-end human resource operations, ensuring regulatory compliance, optimizing workforce planning, and fostering a positive and performance-driven workplace culture.',
    responsibilities: [
      'Manage complete recruitment cycle including sourcing, interviews, selection, and onboarding',
      'Maintain employee records, attendance systems, and HRMIS updates',
      'Coordinate payroll processing and employee benefits administration',
      'Develop, update, and implement HR policies in accordance with labor laws',
      'Handle employee relations, disciplinary matters, and grievance resolution',
      'Lead performance evaluation processes and staff development initiatives',
      'Organize training programs and capacity-building activities',
      'Conduct workforce planning and staffing optimization',
    ],
    education: [
      "MBA (HR), Master's in HRM, or BBA (HR)",
      'Minimum 3–5 years of relevant HR experience',
      'Prior experience in healthcare HR or compliance-focused environments will be preferred',
      'Strong understanding of labor laws, HR governance, and HRMIS systems',
    ],
    kpis: [
      'Timely recruitment and manpower fulfillment',
      'HR compliance and governance standards',
      'Employee engagement and retention rates',
      'Performance improvement and workforce efficiency',
    ],
    eligibilityCriteria: {
      minYearsExperience: 3,
      educationKeywords: ['mba', 'hr', 'hrm', 'bba', 'human resource'],
    },
  },
  {
    id: 'managing-director',
    title: 'Managing Director',
    location: 'Islamabad',
    department: 'Executive Management',
    type: 'Full-Time',
    overview:
      'Capital Care International Hospital & Capital Diagnostic Centre seek a visionary and results-driven Managing Director to lead a multi-facility healthcare network. The role demands strategic leadership, operational excellence, and strong governance to drive sustainable growth.',
    responsibilities: [
      'Provide overall strategic leadership and organizational governance',
      'Oversee hospital and diagnostic center operations',
      'Lead service growth, expansion planning, and innovation',
      'Ensure quality standards, patient safety, and accreditation',
      'Manage regulatory compliance and healthcare governance',
      'Oversee financial control, budgeting, and resource optimization',
      'Lead risk management and senior leadership teams',
    ],
    education: [
      "MBBS / MBA / Master's (Health Administration or related field)",
      'Postgraduate qualification in Healthcare Management preferred',
      'Maximum 10+ years of senior management experience',
      'Age preference: 40–55 years',
    ],
    kpis: [
      'Strategic leadership and governance effectiveness',
      'Operational excellence and service quality',
      'Financial performance, budgeting, and risk management',
    ],
    eligibilityCriteria: {
      minYearsExperience: 10,
      minAge: 40,
      maxAge: 55,
      educationKeywords: ['mbbs', 'mba', 'master', 'health administration', 'healthcare management'],
    },
  },
  {
    id: 'manager-finance',
    title: 'Manager Finance',
    location: 'Islamabad',
    department: 'Finance',
    type: 'Full-Time',
    overview:
      'We are seeking a competent, detail-oriented, and strategic Manager Finance to oversee financial operations across our healthcare facilities, ensuring accuracy, compliance, and financial efficiency.',
    responsibilities: [
      'Financial planning, budgeting, and forecasting',
      'Maintain financial records, ledgers, and bank reconciliations',
      'Manage cash flow, billing, invoicing, and revenue cycles',
      'Coordinate payroll and monitor departmental expenses',
      'Ensure compliance with accounting standards and tax regulations',
      'Prepare financial reports and management analysis',
      'Oversee audits, internal controls, and risk management',
      'Supervise finance team and report to senior management',
    ],
    education: [
      'MBA Finance / M.Com / ACCA / CA / CFA',
      'Healthcare finance experience preferred',
      'Minimum 3–5 years of relevant experience',
    ],
    skills: [
      'Strong financial and budgeting skills',
      'Knowledge of taxation and regulatory compliance',
      'Analytical and problem-solving abilities',
      'Team leadership and communication skills',
      'Proficiency in MS Office and accounting software',
    ],
    kpis: [
      'Accurate financial reporting and compliance',
      'Budget adherence and cost control',
      'Improved cash flow and financial performance',
      'Strong internal controls and audit readiness',
    ],
    eligibilityCriteria: {
      minYearsExperience: 3,
      educationKeywords: ['mba', 'finance', 'm.com', 'mcom', 'acca', 'ca', 'cfa', 'commerce', 'accounting'],
    },
  },
  {
    id: 'manager-admin',
    title: 'Manager Admin',
    location: 'Islamabad',
    department: 'Administration',
    type: 'Full-Time',
    overview:
      'We are looking for a proactive Manager Admin to oversee general administration, facility operations, and support services. This role ensures smooth day-to-day operations and efficient coordination across departments.',
    responsibilities: [
      'Oversee facility management, housekeeping, and support services',
      'Coordinate vendor management and procurement support',
      'Manage office administration, documentation, and record keeping',
      'Ensure safety, security, and compliance with policies',
      'Support events, meetings, and inter-department coordination',
      'Maintain assets, inventory, and administrative budgets',
    ],
    education: [
      "MBA / Master's / Bachelor's in Business Administration or related field",
      'Minimum 3–5 years of administration experience',
      'Experience in healthcare or large organizations preferred',
    ],
    traits: [
      'Strong organizational and communication skills',
      'Problem-solving mindset and attention to detail',
      'Ability to manage vendors and cross-functional teams',
    ],
    kpis: [
      'Efficient facility operations and service quality',
      'Vendor performance and cost optimization',
      'Compliance with safety and administrative policies',
    ],
    eligibilityCriteria: {
      minYearsExperience: 3,
      educationKeywords: ['mba', 'master', 'bachelor', 'business administration', 'administration', 'bba'],
    },
  },
  {
    id: 'videographer-photographer',
    title: 'Videographer / Photographer',
    location: 'Islamabad',
    department: 'Media & Marketing',
    type: 'Full-Time',
    overview:
      'We are looking for a creative and detail-oriented Videographer / Photographer to capture high-quality visual content for hospital branding, doctor profiles, patient awareness campaigns, corporate events, and digital marketing use. The role requires strong visual storytelling skills and the ability to work effectively in a fast-paced healthcare environment.',
    responsibilities: [
      'Capture professional photos and videos for hospital branding and marketing campaigns',
      'Cover corporate events, doctor activities, patient awareness drives, and hospital facilities',
      'Plan lighting, framing, composition, and audio setup for shoots',
      'Maintain visual consistency across all photo and video content',
      'Edit and deliver content within deadlines for digital and print usage',
      'Coordinate with marketing and design teams on creative requirements',
    ],
    education: [
      "Bachelor's degree in Media Studies, Mass Communication, Film & TV, Photography, or a related field",
      'Relevant certifications are a plus',
      '2-4 years of professional photography/videography experience',
      'Healthcare or corporate industry experience preferred',
    ],
    skills: [
      'DSLR and mirrorless cameras such as Sony, Canon, and Nikon',
      'Lighting setup and audio recording',
      'Photo composition and visual storytelling',
      'Adobe Lightroom and Adobe Photoshop',
      'Camera settings including ISO, aperture, and shutter speed',
      'Gimbal and stabilizer operation',
      'Basic drone operation preferred',
    ],
    traits: [
      'Strong branding awareness and visual consistency',
      'Ability to work under deadlines',
      'Comfortable covering live events and on-site hospital environments',
    ],
    kpis: [
      'High-quality visual content delivered on time',
      'Consistent brand presentation across campaigns',
      'Effective coverage of hospital events and awareness activities',
    ],
    eligibilityCriteria: {
      minYearsExperience: 2,
      educationKeywords: ['media studies', 'mass communication', 'film', 'tv', 'photography', 'photographer', 'videographer'],
    },
  },
  {
    id: 'video-editor',
    title: 'Video Editor',
    location: 'Islamabad',
    department: 'Media & Marketing',
    type: 'Full-Time',
    overview:
      'We are seeking a skilled Video Editor to produce engaging short-form and promotional content for social media, campaigns, and hospital branding. The ideal candidate should be able to turn raw footage into polished, story-driven content with a quick turnaround.',
    responsibilities: [
      'Edit Instagram Reels, Facebook Reels, TikTok videos, and YouTube Shorts',
      'Create corporate promotional videos and campaign content',
      'Add motion graphics, animated titles, transitions, and captions',
      'Perform color correction, color grading, and audio enhancement',
      'Coordinate with the media and marketing team to meet creative goals',
      'Deliver edited assets within fast turnaround timelines',
    ],
    education: [
      "Bachelor's degree in Media Studies, Graphic Design, Film Production, or a related field",
      '2-4 years of professional video editing experience',
      'Experience with digital and corporate content preferred',
    ],
    skills: [
      'Adobe Premiere Pro',
      'Adobe After Effects',
      'DaVinci Resolve',
      'CapCut Pro',
      'Adobe Audition preferred',
      'Creative storytelling and pacing',
      'Audio synchronization and sound enhancement',
    ],
    kpis: [
      'Timely delivery of polished video content',
      'Strong engagement-ready social media edits',
      'Consistent output for campaigns and promotional materials',
    ],
    eligibilityCriteria: {
      minYearsExperience: 2,
      educationKeywords: ['media studies', 'graphic design', 'film production', 'video editing', 'editing'],
    },
  },
  {
    id: 'social-media-executive-content-creator',
    title: 'Social Media Executive / Content Creator',
    location: 'Islamabad',
    department: 'Media & Marketing',
    type: 'Full-Time',
    overview:
      'We are hiring a Social Media Executive / Content Creator to manage daily social media activity, support content planning, and help build an engaging digital presence for the hospital. This role is ideal for someone who understands healthcare communication and can create clear, professional, and audience-friendly content.',
    responsibilities: [
      'Plan and manage social media content across major platforms',
      'Create engaging captions, visuals, and campaign ideas',
      'Support social media ads, reporting, and performance analysis',
      'Coordinate content with design, video, and marketing teams',
      'Monitor trends, engagement, and audience feedback',
      'Maintain consistent brand voice and visual style',
    ],
    education: [
      "Bachelor's degree in Marketing, Mass Communication, Media Studies, Digital Marketing, or a related field",
      '2-3 years of social media management experience',
      'Healthcare marketing experience preferred',
    ],
    skills: [
      'Meta Business Suite',
      'Canva Pro',
      'ChatGPT or other AI content tools',
      'Meta Ads Manager',
      'Google Analytics basic knowledge',
      'Basic SEO knowledge',
      'Microsoft Office, including Excel and PowerPoint',
    ],
    traits: [
      'Creative, organized, and proactive',
      'Strong written communication skills',
      'Comfortable working with deadlines and multiple campaigns',
    ],
    kpis: [
      'Consistent content output and campaign execution',
      'Improved engagement and audience growth',
      'Accurate social media reporting and brand alignment',
    ],
    eligibilityCriteria: {
      minYearsExperience: 2,
      educationKeywords: ['marketing', 'mass communication', 'media studies', 'digital marketing', 'social media'],
    },
  },
  {
    id: 'lab-manager',
    title: 'Lab Manager',
    location: 'Islamabad',
    department: 'Laboratory',
    type: 'Full-Time',
    overview:
      'We are looking for an experienced Lab Manager to oversee laboratory operations, quality control, workflow coordination, and team supervision. The role requires strong technical understanding and the ability to manage day-to-day laboratory processes efficiently.',
    responsibilities: [
      'Oversee laboratory operations, staff coordination, and workflow management',
      'Maintain quality assurance, safety, and compliance standards',
      'Monitor sample processing, reporting, and service turnaround times',
      'Coordinate with doctors, administration, and support teams as needed',
      'Maintain inventory, equipment checks, and laboratory documentation',
      'Support continuous improvement in laboratory processes and performance',
    ],
    education: [
      'BS / MLT / MSc or a relevant qualification in Medical Laboratory Sciences or Technologist studies',
      'Minimum 3-5 years of relevant experience, preferably at a managerial level',
    ],
    skills: [
      'Laboratory workflow management',
      'Quality control and safety compliance',
      'Staff supervision and coordination',
      'Record keeping and documentation',
      'Problem solving and decision making',
    ],
    traits: [
      'Detail-oriented and responsible',
      'Strong leadership and communication skills',
      'Able to manage pressure in a clinical environment',
    ],
    kpis: [
      'Smooth laboratory operations and team coordination',
      'Quality and compliance adherence',
      'Efficient reporting and turnaround times',
    ],
    eligibilityCriteria: {
      minYearsExperience: 3,
      educationKeywords: ['bs', 'mlt', 'msc', 'medical laboratory', 'laboratory sciences', 'technologist'],
    },
  },
];

export const DEPARTMENTS = [...new Set(JOBS.map((j) => j.department))];

export const JOB_LOCATIONS = [...new Set(JOBS.map((j) => j.location))];

export const PAKISTAN_PROVINCES = [
  'Punjab',
  'Sindh',
  'Khyber Pakhtunkhwa',
  'Balochistan',
  'Islamabad Capital Territory',
  'Gilgit-Baltistan',
  'Azad Jammu & Kashmir',
];

export function getJobById(jobId) {
  return JOBS.find((j) => j.id === jobId) || JOBS[0];
}
